import { render, staticRenderFns } from "./planner-calendar.vue?vue&type=template&id=3c70c95c&scoped=true"
import script from "./planner-calendar.vue?vue&type=script&lang=js"
export * from "./planner-calendar.vue?vue&type=script&lang=js"
import style0 from "./planner-calendar.vue?vue&type=style&index=0&id=3c70c95c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c70c95c",
  null
  
)

export default component.exports